import React from 'react'
import { Card, Heading, Skeleton, Text } from '@liquidcollectibles/uikit'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { compareDesc } from 'date-fns'
import { useGetCollections } from 'state/collectibles/hooks'
import { FetchAllCollectionsApi } from 'hooks/licoApi'
import CollectionCard from './CollectionCard'

const CollectionGrid = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 1fr;

  ${({ theme }) => theme.mediaQueries.lg} {
    grid-template-columns: repeat(3, 1fr);
  }
`

const NewCollections = () => {
  const collectionsLocal = useGetCollections()
  const collectionsApi = FetchAllCollectionsApi()
  const sorted = collectionsApi?.sort((a, b) => compareDesc(new Date(a.updatedAt), new Date(b.updatedAt)))
  const sortedSlice = sorted?.slice(0, 3)
  const sortedAddresses = []
  sortedSlice?.map(({ contractAddress }) => sortedAddresses.push(contractAddress))
  const collectionsToShow = collectionsLocal?.filter(({ nftAddress }) => sortedAddresses?.includes(nftAddress))

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: 'white',
          marginBottom: 32,
        }}
      >
        <Heading scale="lg">New Collections</Heading>
        <Link to="/collections">
          <Text color="primary" bold>
            View All
          </Text>
        </Link>
      </div>
      <CollectionGrid>
        {collectionsToShow ? (
          <>
            {collectionsToShow.map((col) => (
              <CollectionCard collection={col} key={col.nftAddress} />
            ))}
          </>
        ) : (
          <>
            {[1, 2, 3].map((num) => (
              <Card style={{ borderRadius: 6 }} key={num}>
                <Skeleton width="250px" height="150px" />
              </Card>
            ))}
          </>
        )}
      </CollectionGrid>
    </div>
  )
}

export default NewCollections
